import moment from "moment";
import { API_DATE_FORMAT } from "src/consts/global";

const MONTH_SPAN = 3;

export const getStartEndDate = () => {
  const startDate = moment().startOf("month").subtract(MONTH_SPAN, "months");

  // Add 1 extra day for the end date to include the last day of the month
  const endDate = moment().startOf("month").add(MONTH_SPAN, "months");

  return {
    apiStartDate: startDate.format(API_DATE_FORMAT),
    apiEndDate: endDate.format(API_DATE_FORMAT),
  };
};
